// extracted by mini-css-extract-plugin
module.exports = {"menu":"NavMenu_menu__1A_Q2","logo":"NavMenu_logo__39sdo","logoText":"NavMenu_logoText__3PSjQ","buttonText":"NavMenu_buttonText__1j7qT"};